import { render } from "./TransactionScreen.vue?vue&type=template&id=3fc2596e&scoped=true"
import script from "./TransactionScreen.vue?vue&type=script&lang=js"
export * from "./TransactionScreen.vue?vue&type=script&lang=js"

import "./TransactionScreen.vue?vue&type=style&index=0&id=3fc2596e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc2596e"]])

export default __exports__